import React from 'react';

import { S3_BUCKET_URL } from '@/constants.ts';
import { useOnboarding } from '@/pages/Onboarding/context';
import { inviteOverSceneChoices } from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/choicePanelOptions';
import { GenericScreenLayout } from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/GenericScreenLayout';

export const InviteOverScreen: React.FC = () => {
  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <GenericScreenLayout
      backgroundImage={`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/invite-over-scene.png`}
      title="...My place’s nearby"
      choices={inviteOverSceneChoices.map((option) => ({
        ...option,
        onClick: handleNextStep,
      }))}
    />
  );
};
